import { ACTIVE_TAB, BANK_ACCOUNT } from "../../constants/ActionTypes";

export const fetchActiveTab = (data) => {
  return {
    type: ACTIVE_TAB,
    payload: data,
  };
};

export const fetchBankAccount = (data) => {
  return {
    type: BANK_ACCOUNT,
    payload: data,
  };
};
